import * as React from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";

////////////////////////////////////////////////////////////////////////////

export interface IMenuItem {
    text: string;
    value: any;
    group: number;
}

interface IProps {
    title: string
    text: string
    error?: boolean
    items: Array<IMenuItem>;
    startIcon?: React.ReactNode;
    onChange: (selectedValue: any) => void;
}

interface IMenuState {
    anchor: Element | null;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Componente dropdown para menu
 * @param props
 */
export const MprcDropdown: React.FC<IProps> = (props) => {

    const { title, text, items, startIcon, error, onChange } = props;

    const [state, setState] = React.useState<IMenuState>({
        anchor: null
    });

    const menuItems = React.useMemo(() => {
        var nodes: React.ReactNode[] = [];

        items?.forEach((v, index, arr) => {
            if (index > 0 && arr[index].group != arr[index - 1].group) {
                nodes.push(<Box sx={{ mt: 1.5 }} key={`${index}_divider`} />);
            }
            nodes.push(
                <MenuItem
                    key={index}
                    onClick={() => {
                        setState({ anchor: null });
                        onChange(v.value);
                    }}
                >
                    {v.text}
                </MenuItem>
            );
        });
        return nodes;
    }, [items]);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <Button
                color={error ? "error" : "inherit"}
                variant={error ? "outlined" : undefined}
                size="medium"
                title={title}
                onClick={(e) => {
                    setState({ anchor: e.currentTarget });
                }}
                startIcon={startIcon}
                endIcon={startIcon ? undefined : <KeyboardArrowDownIcon />}
            >
                <Typography variant="overline" component="p">{text}</Typography>
            </Button>
            <Menu
                anchorEl={state.anchor}
                open={state.anchor != null}
                onClose={
                    () => {
                        setState({ anchor: null });
                    }
                }
            >
                {menuItems}
            </Menu>
        </>
    );
};
